import React, { Component } from "react";
import { Growl } from "primereact/growl";
import Spinner from "../../../../Common/Spinner";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import * as appConst from "../../../../Common/constants";

class CogAddEdit extends Component {
  constructor(props) {
    super(props);

    var
      _id,
      _sku,
      _masterSku,
      _cog,
      _gst,
      _transportationCost,
      _stockistMarkup,
      _stockist,
      _mode;
    if (this.props.pData.id == "NA") {
      _id = "NA";
      _sku = "";
      _masterSku = "";
      _cog = 0;
      _gst = 0.0;
      _transportationCost = 0.0;
      _stockistMarkup = 0.0;
      _stockist = "";
      _mode = "add";
    } else {
      _id = this.props.pData.id;
      _sku = this.props.pData.sku;
      _masterSku = this.props.pData.masterSku;
      _cog = this.props.pData.cog;
      _gst = this.props.pData.gst;
      _transportationCost = this.props.pData.transportationCost;
      _stockistMarkup = this.props.pData.stockistMarkup;
      _stockist = this.props.pData.stockist;
      _mode = "edit";
    }

    this.state = {
      id: _id,
      sku: _sku,
      masterSku: _masterSku,
      cog: _cog,
      gst: _gst,
      transportationCost: _transportationCost,
      stockistMarkup: _stockistMarkup,
      stockist: _stockist,
      spinnerClass: "collapse",
      dataClass: "",
      mode: _mode
    };
  }

  render() {
    return (
      <div>
        <h5 align="center"> {this.getHeading()}</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid">
            <div className="row p-1 border">
              <div className="col col-md-2">SKU</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  value={this.state.sku}
                  onChange={e => this.setState({ sku: e.target.value })}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Master SKU</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  value={this.state.masterSku}
                  onChange={e => this.setState({ masterSku: e.target.value })}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Stockist</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  value={this.state.stockist}
                  onChange={e => this.setState({ stockist: e.target.value })}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">COG</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  keyfilter="money"
                  value={this.state.cog}
                  onChange={e => this.setState({ cog: e.target.value })}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">GST Percentage</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  keyfilter="money"
                  value={this.state.gst}
                  onChange={e => this.setState({ gst: e.target.value })}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Transportation Cost</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  keyfilter="money"
                  value={this.state.transportationCost}
                  onChange={e => this.setState({ transportationCost: e.target.value })}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Stockist Markup</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  keyfilter="money"
                  value={this.state.stockistMarkup}
                  onChange={e => this.setState({ stockistMarkup: e.target.value })}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <button
                onClick={this.onSaveClick}
                className="btn btn-primary btn-md mr-2"
              >
                Save
              </button>
              <button
                onClick={this.onClearClick}
                className="btn btn-primary btn-md mr-2"
              >
                Clear
              </button>
              <button
                onClick={this.onCancelClick}
                className="btn btn-primary btn-md mr-2"
              >
                Cancel
              </button>
            </div>
            <Growl ref={el => (this.growl = el)} />
          </div>
        </div>
      </div>
    );
  }

  getHeading() {
    if (this.state.id == "NA" || this.state.id == "") {
      return "Add New COG";
    } else {
      return "Edit COG for SKU " + this.state.sku;
    }
  }

  onSaveClick = async e => {
    e.preventDefault();

    if (
      this.state.sku !== ""
    ) {
      const obj = {
        sku: this.state.sku,
        masterSku: this.state.masterSku,
        cog: this.state.cog,
        gst: this.state.gst,
        transportationCost: this.state.transportationCost,
        stockistMarkup: this.state.stockistMarkup,
        stockist: this.state.stockist,
        platform: "FK"
      };
      if (this.state.mode === "add") {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
            "/Cog",
            obj
          )
          .then(
            res => {
              if (res.status === 200) {
                this.ClearData();
                this.growl.show({
                  severity: "success",
                  summary: "Success",
                  detail: "COG Added !!!"
                });
              } else if (res.status === 204) {
                this.growl.show({
                  severity: "error",
                  summary: "Error !!",
                  detail: "SKU already exists !!"
                });
              }
            }
          );
      } else {
        axios
          .put(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
            "/Cog/" +
            this.props.pData.id,
            obj
          )
          .then(res => {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "COG Updated !!!"
            });
            this.props.onClick("List", null);
          });
      }
    }
  };

  ClearData() {
    this.setState({
      sku: "",
      masterSku: "",
      stockist: "",
      cog: 0,
      gst: 0,
      transportationCost: 0,
      stockistMarkup: 0
    });
  }

  onClearClick = e => {
    this.ClearData();
    this.growl.show({
      severity: "success",
      summary: "Success",
      detail: "Data Cleared !!!"
    });
  };

  onCancelClick = e => {
    this.props.onClick("List", null);
  };
}

export default CogAddEdit;
